export const liveGamesProviders = [
  'ImagineLive',
  'Atmosfera',
  'BetGames',
  'SkillGames',

  // P2P(Belote, Backgammon, Domino, Pasoor (Toto11),
  // eslint-disable-next-line max-len
  // Hokm (Baron), Hexagon) ; BoG (Keno, Crash, HiLo, Keno Express, Sic-bo, Racketon, Penalty, Blackjack, Cash Show (premium))
];

// export const VirtualGamesProviders = [
// 'VirtualSport',
// ];

export const neededProviders = [
  'Galaxsys',
];

export const hideProviders = [
  'Tom Horn',
  'InBet',
  'Endorphina',
  'SmartSoft',
  'Genii',
  'Betsolutions',
  'Atmosfera',
  'TrippleCherry',
];

const tabs = {
  'crash': [
    '37886',
    '18480',
  ]
}


export function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

